<template>
  <Content>
    <Card :noHeader="true">
      <ValidationObserver ref="form">
        <div class="form-group">
          <InputCheckbox v-model="checkbox" :noLabel="true" class="d-inline-block" rules="checked"></InputCheckbox>
        </div>
        <div class="form-group">
          <Button @click="onValidar">
            Validar
          </Button>
        </div>
      </ValidationObserver>
    </Card>
  </Content>
</template>

<script>
import Button from "../modules/shared/components/Button.vue";
import Card from "../modules/shared/components/Card.vue";
import Content from "../modules/shared/components/Content.vue";
import InputCheckbox from "../modules/shared/components/InputCheckbox.vue";
export default {
  components: { InputCheckbox, Content, Card, Button },
  data() {
    return {
      checkbox: false,
      options: [
        {
          value: "peru",
          label: "Perú",
        },
        {
          value: "bolivia",
          label: "Bolivia",
        },
        {
          value: "chile",
          label: "Chile",
        },
      ],
    };
  },
  methods: {
    async onValidar() {
      console.log(await this.$refs.form.validate());
    },
  },
};
</script>
